import React, {ChangeEvent, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {getSecurityReflectionSampleThunk, loadSecurityReflectionThunk} from "../../redux/securityReflection";
import {Box, List, ListItem, Paper, Typography} from "@material-ui/core";
import {Strings} from "../../Resources/Strings";
import {SecurityReflectionAdminComponent} from "./SecurityReflectionAdminComponent";
import {appRoles} from "../../authentication/appRoles";
import {elevation, margin, padding} from "../../styles/styleConstants";

export function SecurityReflectionComponent() {

    const {identity} = useSelector((state: RootState) => state.authentication)
    const dispatch = useDispatch()
    const {securityReflections} = useSelector((state: RootState) => state.securityReflection)

    useEffect(() => {
        async function loadSecurityReflections() {
            await dispatch(loadSecurityReflectionThunk)
        }

        // noinspection JSIgnoredPromiseFromCall
        loadSecurityReflections()
    }, [])


    return <>
        {/*Admin area*/}
        {identity.credentials.roles.includes(appRoles.admin) && <>
            <Box p={padding} m={margin}>
                <Paper elevation={elevation}>
                    <SecurityReflectionAdminComponent/>
                </Paper>
            </Box>
        </>}

        <Typography variant='h6'>{Strings.InChargeOfAnnotations}</Typography>
        <List>
            {securityReflections.map(value => {
                return <ListItem key={value.email}>
                    <Typography
                        variant='body1'><b>{value.email}</b> {value.date.toLocaleDateString()}
                    </Typography>
                </ListItem>
            })}
        </List>
    </>
}